import { render, staticRenderFns } from "./popup-do.vue?vue&type=template&id=3d56c546&scoped=true"
import script from "./popup-do.vue?vue&type=script&lang=js"
export * from "./popup-do.vue?vue&type=script&lang=js"
import style0 from "./popup-do.vue?vue&type=style&index=0&id=3d56c546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56c546",
  null
  
)

export default component.exports